import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAgreementRequest } from '../models/request/agreement/AddAgreementRequest';
import { GetAgreementListPagingAndFilterRequest } from '../models/request/agreement/GetAgreementListPagingAndFilterRequest';

export class AgreementService {
    static async getAgreementList(_isCustomActive: boolean, _isOpenArea: boolean | undefined, _isClosedArea: boolean | undefined, _isHeatControllerRoom: boolean | undefined, _heatControlDetailId: string | undefined, _selectedCompanyId: string | undefined) {
        try {
            var inputObj = {
                isCustomActive: _isCustomActive,
                isOpenArea: _isOpenArea,
                isClosedArea: _isClosedArea,
                isHeatControllerRoom: _isHeatControllerRoom,
                heatControlDetailId: _heatControlDetailId,
                selectedCompanyId: _selectedCompanyId
            };

            console.log('SERVICE CALL - getAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/getAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAgreementList(inputObj: GetAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/exportAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAgreementListPagingAndFilter(inputObj: GetAgreementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAgreementListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/GetAgreementListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAgreement(inputObj: AddAgreementRequest) {
        try {
            console.log('SERVICE CALL - AddAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/AddAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAgreement(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAgreement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/deleteAgreement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAgreementById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAgreementById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Agreement/getAgreementById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}